/*
 * CLP / carousel quick-add upsell dialog.
 *
 * Off until Intelligems (or anything else) turns it on:
 *   document.documentElement.classList.add('fd-plp-upsell');
 * Also honors window.__fdPlpUpsell === true and body.fd-plp-upsell.
 *
 * Product list comes from <script class="fd-plp-upsell-data"> on the card,
 * built from custom.upsell_cards_plp, or shared via data-upsell-ref.
 */
(function fdPlpUpsellModule() {
  if (window.fdPlpUpsell) return;

  var pending = null;

  function routineEnabled() {
    return (
      document.documentElement.classList.contains("fd-pdp-upsell-v2") ||
      document.body.classList.contains("fd-pdp-upsell-v2") ||
      (!!window.Shopify?.theme?.role &&
        window.Shopify.theme.role !== "main" &&
        new URLSearchParams(location.search).get("upsell_v2") === "a")
    );
  }

  function routineCatalog(sectionId) {
    try {
      var node = document.querySelector(
        '[data-plp-routine-catalog="' + sectionId + '"]',
      );
      return node ? JSON.parse(node.textContent).family || [] : [];
    } catch (_) {
      return [];
    }
  }

  function enabled() {
    return (
      routineEnabled() ||
      window.__fdPlpUpsell === true ||
      document.documentElement.classList.contains("fd-plp-upsell") ||
      document.body.classList.contains("fd-plp-upsell")
    );
  }

  function findNode(button, productId) {
    var card = button && button.closest && button.closest("[data-fd-plp-card]");
    var scoped = card && card.querySelector("script.fd-plp-upsell-data");
    if (scoped) return scoped;
    if (productId) {
      return document.querySelector(
        'script.fd-plp-upsell-data[data-product-id="' + productId + '"]',
      );
    }
    return null;
  }

  function readPayload(node) {
    if (!node) return null;
    var source = node;
    var ref = node.getAttribute("data-upsell-ref");
    if (ref)
      source = document.querySelector(
        'script.fd-plp-upsell-data[data-upsell-key="' + ref + '"]',
      );
    if (!source) return null;
    var products;
    try {
      products = JSON.parse(source.textContent);
    } catch (err) {
      console.warn("[fd-plp-upsell] bad payload", err);
      return null;
    }
    if (!Array.isArray(products) || (!products.length && !routineEnabled()))
      return null;

    var price = parseInt(node.dataset.price, 10);
    var compare = parseInt(node.dataset.compare, 10);
    if (!Number.isFinite(price)) price = 0;
    if (!Number.isFinite(compare) || compare <= 0) compare = price;

    return {
      productId: node.dataset.productId || "",
      variantId: node.dataset.variantId || "",
      handle: node.dataset.handle || "",
      title: node.dataset.title || "",
      shortName: node.dataset.shortName || "",
      imageUrl: node.dataset.image || "",
      demographic: node.dataset.demographic || "",
      price: price,
      compare: compare,
      products: products,
    };
  }

  function readGiftConfig() {
    var pdp = document.getElementById("PBFCM-gift-config-data");
    var fallback = document.getElementById("fd-upsell-dialog-gift-fallback");
    var node = pdp || fallback;
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function planIdLooksNinety(planId) {
    var id = String(planId || "").trim();
    if (!id) return false;
    var quarterly = document.querySelector(
      '[data-frequency-period="quarterly"], [data-days="90"]',
    );
    if (quarterly && String(quarterly.dataset.sellingPlan || "").trim() === id)
      return true;
    var upgrade = document.querySelector("[data-plan-upgrade-to]");
    if (upgrade && String(upgrade.dataset.planUpgradeTo || "").trim() === id)
      return true;
    return false;
  }

  function pickUpsellPlan(info, clickedPlanId, isSubscription) {
    if (!isSubscription) return null;
    var candidates = [info && info.sellingPlanId, clickedPlanId];
    var i;
    for (i = 0; i < candidates.length; i++) {
      var id = String(candidates[i] || "").trim();
      if (id && !planIdLooksNinety(id)) return id;
    }
    return null;
  }

  function discountProps(sellingPlanId) {
    var props = {};
    var carouselOverride = window.__pbfcmCarouselDiscountOverride || null;
    var pdpOverride = window.__pdpDiscountOverride || null;
    var override = carouselOverride || pdpOverride;
    if (override) {
      var otpCode = override.otpCouponCode || override.couponCode || "";
      var subCode = override.subCouponCode || override.couponCode || "";
      if (otpCode) props._otp_discount_code = String(otpCode);
      if (subCode) props._sub_discount_code = String(subCode);
      if (
        typeof override.discountPercent === "number" &&
        Number.isFinite(override.discountPercent)
      ) {
        props._otp_discount_percentage = String(override.discountPercent);
      }
      var subPct =
        typeof override.subDiscountPercent === "number" &&
        Number.isFinite(override.subDiscountPercent)
          ? override.subDiscountPercent
          : typeof override.discountPercent === "number" &&
              Number.isFinite(override.discountPercent)
            ? override.discountPercent
            : null;
      if (subPct !== null) props._sub_discount_percentage = String(subPct);
      props._discount_source = carouselOverride
        ? "pbfcm-product-carousel"
        : "pdp";
    }
    if (sellingPlanId)
      props._if_upgrade__selling_plan_id = String(sellingPlanId);
    return props;
  }

  function applyCoupon(props, coupon, isSubscription) {
    var code = coupon ? String(coupon).trim() : "";
    if (!code) return props;
    props._upsell_discount_code = code;
    if (isSubscription) props._sub_discount_code = code;
    else props._otp_discount_code = code;
    return props;
  }

  function baseProps(sellingPlanId, isSubscription) {
    var props = Object.assign(
      {
        _full_price: "true",
        _product_type: "rebrand",
        _is_upsell: "true",
        _upsell_module: "plp_upsells_dialog",
        _page_path: window.location.pathname,
      },
      discountProps(sellingPlanId),
    );
    if (isSubscription) props._is_subscription_purchase = "true";
    else props._is_one_time_purchase = "true";
    return props;
  }

  function lineItem(
    variantId,
    quantity,
    isSubscription,
    sellingPlanId,
    properties,
  ) {
    var item = {
      id: parseInt(variantId, 10),
      quantity: quantity,
      properties: properties,
    };
    if (isSubscription && sellingPlanId) item.selling_plan = sellingPlanId;
    return item;
  }

  async function cartHasFreeUnlock() {
    try {
      var cart = await window.FDCartApi.getCart();
      return (cart.items || []).some(function (li) {
        var p = li.properties || {};
        return p._free_unlock === "true" || p._free_unlock === true;
      });
    } catch (err) {
      return false;
    }
  }

  function buildUpsellItems(
    selected,
    clickedPlanId,
    isSubscription,
    freeGiftAlready,
  ) {
    var items = [];
    var giftTaken = freeGiftAlready;

    Object.keys(selected || {}).forEach(function (productId) {
      var info = selected[productId];
      if (!info || !(info.quantity > 0)) return;

      var usePlan = pickUpsellPlan(info, clickedPlanId, isSubscription);
      var useSub = !!usePlan;

      var unlock = info.freeUnlock;
      if (unlock && unlock.variantId && !giftTaken) {
        var freeProps = baseProps(null, false);
        freeProps._free_unlock = "true";
        freeProps._unlocked_by = info.title || "";
        freeProps._bfcm_add_on_promo_price = "0";
        if (unlock.comparePrice > 0)
          freeProps._bfcm_add_on_full_price = String(
            Math.round(unlock.comparePrice),
          );
        if (unlock.discountCode)
          freeProps._unlock_discount_code = String(unlock.discountCode);
        giftTaken = true;
        items.push(lineItem(unlock.variantId, 1, false, null, freeProps));
      }

      var bundle = Array.isArray(info.bundleVariants)
        ? info.bundleVariants
        : [];
      if (bundle.length > 0) {
        var groupId =
          "starter-" +
          Date.now().toString(36) +
          "-" +
          Math.random().toString(36).slice(2, 8);
        var groupTitle = info.bundleName || info.title || "Starter Pack";
        bundle.forEach(function (comp) {
          if (!comp || !comp.id) return;
          var compSub = useSub && comp.prevent !== true;
          var compPlan = compSub
            ? pickUpsellPlan(
                { sellingPlanId: comp.sellingPlanId },
                usePlan,
                true,
              )
            : null;
          var compProps = baseProps(compPlan, compSub);
          compProps._bundle = groupId;
          compProps._bundle_title = groupTitle;
          compProps._bundle_name = info.bundleName || info.title || "";
          if (info.productId) compProps._parent_pdp = String(info.productId);
          if (info.handle) compProps._parent_pdp_handle = String(info.handle);
          var compPromo = compSub ? comp.subscriptionPrice : comp.onetimePrice;
          if (compPromo > 0)
            compProps._bfcm_add_on_promo_price = String(Math.round(compPromo));
          if (comp.fullPrice > 0)
            compProps._bfcm_add_on_full_price = String(
              Math.round(comp.fullPrice),
            );
          if (comp.prevent === true) compProps._prevent_subscription = "true";
          applyCoupon(compProps, info.coupon, compSub);
          items.push(
            lineItem(comp.id, info.quantity, compSub, compPlan, compProps),
          );
        });
        return;
      }

      var props = baseProps(usePlan, useSub);
      var price = info.price || 0;
      if (price > 0) props._bfcm_add_on_promo_price = String(Math.round(price));
      if (info.comparePrice > 0)
        props._bfcm_add_on_full_price = String(Math.round(info.comparePrice));
      applyCoupon(props, info.coupon, useSub);
      items.push(
        lineItem(info.variantId, info.quantity, useSub, usePlan, props),
      );
    });

    return items;
  }

  function handle(ctx) {
    if (!enabled()) return Promise.resolve(false);
    if (pending) return pending;

    var node = findNode(ctx.buttonElement, ctx.productId);
    var payload = readPayload(node);
    if (!payload) return Promise.resolve(false);

    var dialog = document.querySelector("upsell-dialog");
    if (!dialog || typeof dialog.show !== "function")
      return Promise.resolve(false);

    var routine = routineEnabled();
    if (routine) {
      var products = new Map(
        routineCatalog(node.dataset.carouselSection).map(function (product) {
          return [String(product.id), product];
        }),
      );
      payload.products.forEach(function (product) {
        products.set(String(product.id), product);
      });
      products.delete(String(payload.productId));
      payload.products = Array.from(products.values());
      if (!payload.products.length) return Promise.resolve(false);
    }

    var sellingPlanId = ctx.sellingPlanId
      ? String(ctx.sellingPlanId).trim()
      : "";
    var isSubscription = sellingPlanId !== "";
    if (routine) {
      var offer = window.FDOffer && window.FDOffer.active;
      var percent = isSubscription
        ? offer && offer.subPct
        : offer && offer.otpPct;
      if (offer && offer.replacesGlobal && Number.isFinite(percent)) {
        payload.price = Math.round((payload.compare * (100 - percent)) / 100);
        payload.products = payload.products.map(function (product) {
          var sale = Math.round(
            ((product.comparePrice || product.price) * (100 - percent)) / 100,
          );
          var next = Object.assign({}, product, { price: sale });
          if (isSubscription) next.subscriptionPrice = sale;
          else next.onetimePrice = sale;
          return next;
        });
      }
    }
    var previousDemographic = dialog.dataset.mainDemographic || "";
    var button = ctx.buttonElement;
    var ingredients =
      button && button.closest && button.closest(".fd-ingredients-popup");
    if (ingredients) {
      var closer = ingredients.querySelector("[data-fd-ingredients-close]");
      if (closer) closer.click();
    }

    pending = new Promise(function (resolve) {
      var settled = false;
      function finish(handled) {
        if (settled) return;
        settled = true;
        dialog.dataset.mainDemographic = previousDemographic;
        resolve(handled);
      }

      // The add opens the cart drawer: close first so focus returns to the card, not behind the drawer.
      function closeBeforeDrawer() {
        if (
          !window.FDCartPageAdd ||
          typeof window.updateCartDisplay !== "function" ||
          typeof dialog.hide !== "function"
        )
          return;
        if (
          dialog.classList.contains(
            dialog.classes ? dialog.classes.activeClass : "active",
          )
        )
          dialog.hide();
      }

      dialog.dataset.mainDemographic = payload.demographic || "";
      try {
        dialog.show({
          routineData: routine
            ? {
                main: {
                  handle: payload.handle,
                  title: payload.shortName || payload.title,
                  imageUrl: payload.imageUrl,
                },
                family: payload.products,
              }
            : null,
          mainProduct: {
            id: payload.productId,
            variantId: payload.variantId,
            title: payload.title,
            shortName: payload.shortName,
            demographic: payload.demographic,
            price: payload.price,
            subscriptionPrice: payload.price,
            comparePrice: payload.compare,
            quantity: 1,
          },
          upsellProducts: payload.products,
          giftConfig: readGiftConfig(),
          isSubscription: isSubscription,
          preselectedIndex: -1,
          onCheckout: async function (selected) {
            try {
              var hasGift = Object.values(selected).some(function (item) {
                return item.freeUnlock;
              })
                ? await cartHasFreeUnlock()
                : false;
              var extras = buildUpsellItems(
                selected,
                sellingPlanId,
                isSubscription,
                hasGift,
              );
              closeBeforeDrawer();
              await ctx.commit(extras);
              finish(true);
              return true;
            } catch (err) {
              console.error("[fd-plp-upsell] add failed", err);
              return false;
            }
          },
          onDecline: async function () {
            try {
              closeBeforeDrawer();
              await ctx.commit([]);
              finish(true);
              return true;
            } catch (err) {
              console.error("[fd-plp-upsell] add failed", err);
              return false;
            }
          },
        });
      } catch (err) {
        console.error("[fd-plp-upsell] dialog failed to open", err);
        finish(false);
      }
    }).finally(function () {
      pending = null;
    });

    return pending;
  }

  window.fdPlpUpsell = {
    enabled: enabled,
    handle: handle,
  };

  window.fdEnablePlpUpsell = function () {
    window.__fdPlpUpsell = true;
    document.documentElement.classList.add("fd-plp-upsell");
  };
})();
